import { render } from "./WebIndex.vue?vue&type=template&id=605489a1&scoped=true"
import script from "./WebIndex.vue?vue&type=script&lang=js"
export * from "./WebIndex.vue?vue&type=script&lang=js"

import "./WebIndex.vue?vue&type=style&index=0&id=605489a1&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605489a1"]])

export default __exports__